import { Link } from "react-router-dom";

const DynamicPdfCard = ({ heading, images = [], documents = [] }) => {
  const pdfIcon = "/assets/images/pdf.webp";
  const wordIcon = "/assets/images/word.webp";

  return (
    <section className="pb_80">
      <div className="container">
        {images.length > 0 && (
          <div className="row mb-4 justify-content-center">
            {images.map((img, idx) => (
              <div className="col-md-4 col-12 mb-3" key={idx}>
                <img
                  src={img}
                  alt={`Banner ${idx}`}
                  className="img-fluid w-100 rounded"
                  style={{ objectFit: "cover", height: "250px" }}
                />
              </div>
            ))}
          </div>
        )}

        <div className="sec-title text-center">
          <h2>{heading}</h2>
        </div>

        <div className="row d-flex justify-content-center align-items-center">
          {documents.map((item, index) => (
            <div className="col-md-3 col-12 mb-3" key={index}>
              <div className="card esanad-card d-flex flex-row align-items-center">
                <Link
                  to={`${process.env.REACT_APP_API_URL}/public${item.pdfLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex flex-row text-decoration-none text-dark"
                >
                  <div className="dynamic-pdf-wrapper">
                    <img
                      src={item.type === "word" ? wordIcon : pdfIcon}
                      alt="Document Icon"
                      className="img-fluid"
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="d-flex align-items-center p-2">
                    <strong>{item.title}</strong>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DynamicPdfCard;
